import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { SendPaymentInstructionModelService } from './services/send-payment-instruction.model.service';

@Injectable({
  providedIn: 'root'
})
export class AddRecipientFromSendPaymentGuard implements CanActivate {
  constructor(private sendPaymentInstructionModel: SendPaymentInstructionModelService,
    private router: Router) { }

  canActivate() {
    if (this.sendPaymentInstructionModel.currency.id) {
      return true;
    }

    this.router.navigate(['/client/dashboard']);
    return false;
  }
}
